import { parse } from 'csv-parse'
import { FleetDataType } from '../models'

interface Option {
  label: string
  value: string
}

interface Group {
  label: string
  options: Option[]
}

export function transformArray(arr: FleetDataType[]): Group[] {
  const groups: { [key: string]: Option[] } = {}
  arr?.forEach((elem) => {
    if (!groups[elem.country]) {
      groups[elem.country] = []
    }
    groups[elem.country].push({
      label: elem.period,
      value: `${elem.id}`,
    })
  })
  const result: Group[] = []
  for (const [country, options] of Object.entries(groups)) {
    result.push({
      label: country,
      options: options,
    })
  }
  return result
}

export const validateCabifyCSVFile = async (file: File): Promise<boolean> => {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = () => {
      const csv = reader.result as string
      const parser = parse(csv, { columns: true })
      const requiredColumns = ['make_model', 'km_distance']
      const invalidRecords: any[] = []
      parser.on('readable', () => {
        let record
        while ((record = parser.read())) {
          if (
            requiredColumns.some((column) => !record[column]) ||
            isNaN(Number(record['km_distance'])) ||
            Number(record['km_distance']) > 100000
          ) {
            invalidRecords.push(record)
          }
        }
      })
      parser.on('end', () => {
        resolve(invalidRecords.length === 0)
      })
      parser.on('error', () => {
        resolve(false)
      })
    }
    reader.readAsText(file)
  })
}
